import { catchError, map, mapTo, mergeMap } from 'rxjs/operators';
import { ofType } from 'redux-observable-es6-compat';

import { ALoginFailed, ASetLogin, ASetMessage, TUser } from '../actions';
import { of } from 'rxjs';

export const loginEpic = (action$, _, { restApi }) =>
  action$.pipe(
    ofType(TUser.LOGIN),
    mergeMap(({ payload }) => restApi.auth(payload.email, payload.password, payload.rememberMe)),
    map(ASetLogin),
    catchError(err => {
      if (err.status && err.message) {
        setTimeout(() => {
          window.location.reload();
        }, 1500);
        return of(ASetMessage('Les identifiants sont incorrectes'));
      }
      throw new Error(err);
    }),
  );

export const loginDesktopEpic = (action$, _, { restApi }) =>
  action$.pipe(
    ofType(TUser.LOGINDESKTOP),
    mergeMap( ({ payload }) => restApi.post('/init/setBid', payload).pipe(
        catchError(err => {
          if (err.status && err.message) {
            setTimeout(() => {
              window.location.reload();
            }, 3000);
            return of(ALoginFailed('Error while setting bid : ' + err.message));
          }
          throw new Error(err);
        })
    )),
    map((action: TUser.LOGIN_FAILED | any) => {
      if ( action?.type === TUser.LOGIN_FAILED ) {
        return action;
      } else {
        return ASetLogin();
      }
    }),
  );

export const logoutEpic = (action$) =>
  action$.pipe(
    ofType(TUser.LOGOUT),
    mapTo({ type: 'RESET_STATE' })
  );
